import { AutomationWorkflows } from '../../constants/features';
import { useIsSellerFeatureEnabled } from '../../hooks/use-is-seller-feature-enabled';

export const useHasAutomationWorkflowsFeature = () => useIsSellerFeatureEnabled(AutomationWorkflows);
